import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1400 30%, #0d0a00 60%, #0a0a0a 100%)'
  }} data-id="element-230">
      {/* Logo */}
      <div className="mb-4" data-id="element-231">
        <span className="text-[#FFD700] text-xl sm:text-2xl font-black tracking-widest" data-id="element-232">
          🎹 PROFEPACK
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-233">
        Todo tu año de Piano
        <br data-id="element-234" />
        <span className="text-[#FFD700]" data-id="element-235">resuelto.</span>
      </h1>

      {/* Mockup image — LCP element, priority load con dimensiones explícitas */}
      <div className="w-full max-w-[240px] sm:max-w-[300px] md:max-w-sm mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-236">
        <img src="https://cdn.magicpatterns.com/uploads/bRXpU56mEgZ6wMfpHGVyY9/Sin_titulo_(420_x_420_px)_(10).png" alt="PROFEPACK MegaPack Piano Listo — Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" data-id="element-237" />
      </div>

      {/* Subtitle */}
      <p className="text-[#FFD700] text-lg sm:text-2xl font-bold max-w-3xl mb-[0px]" data-id="element-238">
        "Listo para usar. Sin buscar más. Sin improvisar. Sin perder domingos."
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-239">
        El sistema para profesores de piano en Argentina: año completo listo
        (clases + evaluaciones + planificador), sin buscar ni armar desde cero.
      </p>

      {/* Pills */}
      <div className="flex flex-nowrap mb-[10px] gap-1 sm:gap-[5px] items-center justify-center mx-auto px-1" data-id="element-240">
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-241">
          📄 PDF
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-242">
          ⚡ Inmediato
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-243">
          🇦🇷 Argentina
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-244">
          🎹 Todos los niveles
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-green-pulse bg-[#FFD700] text-black font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#FFE44D] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm" data-id="element-245">
        🎹 → QUIERO MI PROFEPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-246">
        <span data-id="element-247">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-248">🔒 Pago 100% seguro</span>
        <span data-id="element-249">💳 Mercado Pago | Tarjeta | Transferencia</span>
      </p>
    </section>;
}